import React, { useState, useEffect, useRef } from "react";
import "./StatsSection.css";

const Counter = ({ end, label }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          let start = 0;
          const duration = 2000;
          const increment = end / (duration / 16);
          const step = () => {
            start += increment;
            if (start < end) {
              setCount(Math.floor(start));
              requestAnimationFrame(step);
            } else {
              setCount(end);
            }
          };
          requestAnimationFrame(step);
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, [end]);

  return (
    <div className="stat-item" ref={ref}>
      <div className="counter-number">
        <span className="counter-value">{count}</span>
      </div>
      <div className="stat-label">{label}</div>
    </div>
  );
};

export default function StatsSection() {
  const [articleCount, setArticleCount] = useState(10);

  useEffect(() => {
    fetch("https://beszeljegyesulet.hu/wp/wp-json/wp/v2/posts?per_page=1")
      .then((res) => {
        const total = parseInt(res.headers.get("X-WP-Total") || "0", 10);
        if (total > 0) {
          // Round down to nearest 10
          setArticleCount(Math.floor(total / 10) * 10);
        }
        return res.json();
      })
      .catch(() => {});
  }, []);

  return (
    <section className="stats-section">
      <div className="stats-background"></div>
      <div className="stats-container">
        <h2 className="stats-title">Munkásságaink eredményei</h2>
        <div className="stats-grid title-md">
          <Counter end={30} label="BeszÉLJ Tag" />
          <Counter end={articleCount} label="Cikk" />
          <Counter end={20} label="Esemény" />
          <Counter end={10} label="Szakmai előadó" />
        </div>
      </div>
    </section>
  );
}